// extracted by mini-css-extract-plugin
var _1 = "PostTitleWithVerified-module__icon--BMhQr";
var _2 = "PostTitleWithVerified-module__regular--C5BWI";
var _3 = "PostTitleWithVerified-module__small--VTpRG";
export { _1 as "icon", _2 as "regular", _3 as "small" }
